import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  http = inject(HttpClient);

  getCurrentTemperature() {
    const apiKey = '99a7a442b0cc46e99b131517241710';
    const city = 'bangkok';
    const url = `http://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${city}&aqi=no`;


     return this.http.get(url);
  }
}
